/* WHAT IS LEFT AFTER THE SHELL OWNS THE DASHBOARD (#2406).
 *
 * This sheet held `.groupLabel`, `.dash` and `.note` — a hand-written section
 * label, a tile grid and a paragraph of prose. All three existed because the
 * governed figures were rendered in the page BODY instead of in the shell's
 * cap: the labels named groups the shell now names, the grid laid out tiles
 * `StatStrip` lays out, and the paragraph explained a model rather than
 * reporting a state.
 *
 * `.emptyLine` is the one line that is genuinely this page's: the sentence a
 * caught-up operator reads, sized so it sits calmly inside the shared
 * `EmptyState` rather than filling it.
 */
.emptyLine { margin: 0; font-size: var(--fs-sm); }
